import React, { useEffect, useState } from "react";
import { getPurchaseOrderHeaderDetails } from "../../services/purchaseOrderService";
import { getDistributorNames } from "../../Common/functions";

const baseTitles = [
  { title: "Today" },
  { title: "This week" },
  { title: "This month" },
  { title: "Total sales" },
];

const Header = ({
  stats,
  userRole,
  StatsVisibility,
  ButtonVisibility,
  setAddNewSection,
}) => {
  const [values, setValues] = useState(["0", "0", "0", "0"]);

  const getHeadersDetails = async () => {
    try {
      const payload = {
        category: "Sales Order",
      };

      if (userRole !== "super_admin") {
        payload.distributor_name = getDistributorNames(); // Ensure this returns the correct format (e.g., array or string)
      }
      const response = await getPurchaseOrderHeaderDetails(payload);
      const totalRecords = response?.data?.total_records;
      if (totalRecords) {
        setValues([
          totalRecords.Today || 0,
          totalRecords.ThisWeek || 0,
          totalRecords.ThisMonth || 0,
          totalRecords.EntireTime || 0,
        ]);
      } else {
        console.error("Invalid response structure:", response);
      }
    } catch (error) {
      console.error("Error fetching header details:", error);
    }
  };

  useEffect(() => {
    getHeadersDetails();
  }, []);

  return (
    <>
      <div className="px-0 sm:px-4 space-y-4">
        <div className="flex  justify-between gap-2">
          <h1 className="text-2xl sm:text-3xl leading-9 font-bold text-text1">
            Purchase order
          </h1>
          {ButtonVisibility && (
            <div>
              <button
                className="text-white text-sm bg-primary px-3 py-2 rounded-md"
                onClick={() => setAddNewSection(true)}
              >
                Add New
              </button>
            </div>
          )}
        </div>
        <div>
          {StatsVisibility && (
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-5 mb-6">
              {baseTitles.map((item, index) => (
                <div
                  key={index}
                  className="border border-gray-200 rounded-lg p-6 flex justify-between items-center w-full shadow-lg gap-1"
                >
                  <div>
                    <h2 className="text-sm font-medium text-text2 text-left">
                      {item.title}
                    </h2>
                    <p className="text-3xl font-bold text-text2 text-left">
                      {values[index]}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
        <hr />
      </div>
    </>
  );
};

export default Header;
